import {CurrentMaxId} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public CurrentMaxId: CurrentMaxId,
  ) {}
}